export enum CompanyRole {
  MAIN = 'main',
  SALES = 'sales',
  ACCOUNTING = 'accounting',
  SIGNATORY = 'signatory',
  TECHNICAL = 'technical',
}

export const CompanyRoleLoop = new Set<CompanyRole>([
  CompanyRole.SALES,
  CompanyRole.ACCOUNTING,
  CompanyRole.TECHNICAL,
]);
